import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell } from "recharts";

const tip = { background: "rgb(var(--c-elevated))", border: "1px solid rgb(var(--c-line))", borderRadius: 10, color: "rgb(var(--c-ink))", fontSize: 13 };

export default function ProgressChart({ data }) {
  return (
    <div data-testid="subject-progress-chart" className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--chart-grid)" />
          <XAxis dataKey="subject" tick={{ fontSize: 11, fill: "var(--chart-text)", fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
          <YAxis domain={[0, 100]} tick={{ fontSize: 11, fill: "var(--chart-text)" }} axisLine={false} tickLine={false} unit="%" />
          <Tooltip cursor={{ fill: "var(--chart-cursor)" }} contentStyle={tip} labelStyle={{ color: "rgb(var(--c-ink-2))" }} itemStyle={{ color: "rgb(var(--c-ink))" }}
            formatter={(v, _n, p) => [`${v}% (${p.payload.answered} answers)`, p.payload.name]} />
          <Bar dataKey="accuracy" radius={[6, 6, 0, 0]} maxBarSize={48}>
            {data.map((d, i) => <Cell key={i} fill={d.answered === 0 ? "var(--chart-empty)" : d.accuracy >= 60 ? "var(--chart-good)" : "var(--chart-warn)"} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
